/* tslint:disable */
/* eslint-disable */
/**
 * Contract Management API
 * API for managing contracts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContractQuoteDto
 */
export interface ContractQuoteDto {
    /**
     * 
     * @type {string}
     * @memberof ContractQuoteDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ContractQuoteDto
     */
    quoteIdentifier: string;
    /**
     * 
     * @type {Date}
     * @memberof ContractQuoteDto
     */
    creationDate: Date;
    /**
     * 
     * @type {number}
     * @memberof ContractQuoteDto
     */
    priceIncludingTax: number;
    /**
     * 
     * @type {string}
     * @memberof ContractQuoteDto
     */
    statusLabel: string;
    /**
     * 
     * @type {string}
     * @memberof ContractQuoteDto
     */
    statusColor: string;
    /**
     * 
     * @type {string}
     * @memberof ContractQuoteDto
     */
    fileId: string;
}

/**
 * Check if a given object implements the ContractQuoteDto interface.
 */
export function instanceOfContractQuoteDto(value: object): value is ContractQuoteDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('quoteIdentifier' in value) || value['quoteIdentifier'] === undefined) return false;
    if (!('creationDate' in value) || value['creationDate'] === undefined) return false;
    if (!('priceIncludingTax' in value) || value['priceIncludingTax'] === undefined) return false;
    if (!('statusLabel' in value) || value['statusLabel'] === undefined) return false;
    if (!('statusColor' in value) || value['statusColor'] === undefined) return false;
    if (!('fileId' in value) || value['fileId'] === undefined) return false;
    return true;
}

export function ContractQuoteDtoFromJSON(json: any): ContractQuoteDto {
    return ContractQuoteDtoFromJSONTyped(json, false);
}

export function ContractQuoteDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractQuoteDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'quoteIdentifier': json['quoteIdentifier'],
        'creationDate': (new Date(json['creationDate'])),
        'priceIncludingTax': json['priceIncludingTax'],
        'statusLabel': json['statusLabel'],
        'statusColor': json['statusColor'],
        'fileId': json['fileId'],
    };
}

export function ContractQuoteDtoToJSON(json: any): ContractQuoteDto {
    return ContractQuoteDtoToJSONTyped(json, false);
}

export function ContractQuoteDtoToJSONTyped(value?: ContractQuoteDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'quoteIdentifier': value['quoteIdentifier'],
        'creationDate': ((value['creationDate']).toISOString().substring(0,10)),
        'priceIncludingTax': value['priceIncludingTax'],
        'statusLabel': value['statusLabel'],
        'statusColor': value['statusColor'],
        'fileId': value['fileId'],
    };
}

